export default Object.freeze({
  Processing: 0, // Đang xử lý
  Success: 1, // Thành công
  Error: 2, // Thất bại
})
